import { useMsalAuth } from "./use-msal-auth";

/**
 * Custom hook to provide a consistent authentication interface
 * Now uses MSAL auth under the hood
 */
export function useAuthProvider() {
  // Get auth state from MSAL provider
  return useMsalAuth();
}